import {Base} from "@/api/Base"

export class NavList extends Base {
    path = "navList"
}